// console.log("LOCOMIVE_DEV_ANIMS.JS");
var scroll;

function loadVideos() {
    const videos = Array.from(document.querySelectorAll('.video-section'));
    let videoTab = []
    videos.forEach(video => {
        // alert("hello");
        const currentVideo = video.querySelector('.background-video');
        const divID = currentVideo.getAttribute('data-video-id');
        let videoID = divID.split('-')[1];
        let options = {
            url: `https://player.vimeo.com/video/${videoID}`,
            autoplay : true,
            height : '100%',
            muted : true,
            loop : true,
            controls : false,
            paused : false,
            autopause : false,
            background : true
        };
        let videoPlayer = new Vimeo.Player(currentVideo, options);
        console.log(videoPlayer);
        videoTab.push(videoPlayer);
    });

}
loadVideos();


// INIT SMOOTH
var options = {
    el: document.querySelector("#js-scroll"),
    smooth: true,
    getSpeed: true,
    getDirection: true,
    useKeyboard: true,
    lerp: 0.5,
};


let scrollPosition,
    sideMenuShown = false,
    animMapShown = false;
(function() {
    document.documentElement.classList.add("is-loaded");
    document.documentElement.classList.remove("is-loading");

    // SAYS WHEN PAGE IS READY TO SCROLL
    // console.log("SMOOTH INIT");
    scroll = new LocomotiveScroll(options);

    setTimeout(() => {
        // TIMER DE 700 MS
        // console.log("SMOOTH UPDATE 1");
        scroll.update();

        document.documentElement.classList.add("is-ready");

        document.querySelectorAll('.tab-faq').forEach( el => {
            el.addEventListener('click', e => {
                el.classList.toggle('opened');
                scroll.update();
            })
        })
        
        let cptHeaderHide = 0;
        let cptHeaderShow = 0;
        let alreadyUpdated = false;
        
       scroll.on("scroll", function(instance) {
        var progress = 100 * instance.scroll.y / instance.limit.y;
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)

        if (instance.scroll.y > vh) {
            document.querySelector('.rond-fleche.arrow-footer.fixed').classList.remove('hidden');
        } else {
            document.querySelector('.rond-fleche.arrow-footer.fixed').classList.add('hidden');
        }


        if (instance.scroll.y < 20) {
            cptHeaderHide = 0;
            cptHeaderShow = 0;
            document.querySelector('header.main-header').classList.remove('is-hidden');
        }

        if ( !document.querySelector('header.main-header').classList.contains('is-active')) {
            if (instance.direction === 'down') {
                cptHeaderHide++;
                cptHeaderShow = 0;
                if (cptHeaderHide > 20 && !document.querySelector('header.main-header').classList.contains('is-open')) {
                    document.querySelector('header.main-header').classList.add('is-hidden');
                }
            } else {
                cptHeaderHide = 0;
                cptHeaderShow++;
                if (cptHeaderShow > 5) {
                    document.querySelector('header.main-header').classList.remove('is-hidden');
                    document.querySelector('.rond-fleche.arrow-footer').classList.remove('in-bottom')
                }
                
            }
        } 
    });
        

        scroll.on("call", (value, way, obj) => {
            if (value === "animMapHomeIsInView") {
                if (way === "enter" && !animMapShown) {
                    animMapShown = true;
                    launchAnimMapHome();
                }
            }

            if (value === "animAnchorSectionSliderIsInView") {
                if (way === "enter") {
                    //Get element i enter in
                    const monElem = obj.target;
                    //get this element id
                    var monElemId = monElem?.id;
                    // console.log("Mon Element ID " + monElemId);

                    //Select the corresponding anchor
                    var monAncre = document.querySelector("a[href='#" + monElemId + "']");
                    // console.log("Mon Element ID " + monAncre);

                    //remove class from other anchors
                    if (document.querySelector(".activeAnchor")) {
                        var previousAnchor = document.querySelector(".activeAnchor");
                        //remove Class to active Anchor
                        if (previousAnchor) previousAnchor.classList.remove("activeAnchor");
                    }

                    //add Class to active Anchor
                    if (monAncre) monAncre.classList.add("activeAnchor");
                } else {
                    //monAncre.classList.remove("activeAnchor");
                }
            }

            if (value === "tabsIn") {
                //peut être plus utilisé
                // console.log("--------------- anim tabsIn ---------------");
                const monElem = obj.target;

                // console.log(monElem);

                const tab = monElem.getElementsByClassName("tab");

                if (way === "enter") {
                    gsap.to(tab, {
                        duration: 0.8,
                        y: 5,
                        opacity: 1,
                        //rotation: 10,
                        //transformOrigin: "left 50%",
                        ease: Power1.easeInOut,
                        stagger: 0.2,
                    });
                }
            }


            if (value === "latestPost") {
                try {
                    if (!mobile) {
                        const monElem = obj.target;
                        monElem.querySelectorAll(".item").forEach(function(thisElem, index) {
                            const enlargeMargin = index * 100;
                            // console.log(index);
                            gsap.set(thisElem, {
                                translateX: enlargeMargin,
                                opacity: 0,
                            });
                        });
    
                        if (way === "enter") {
                            const items = monElem.querySelectorAll(".item");
                            gsap.to(items, {
                                duration: 1,
                                opacity: 1,
                                translateX: 0,
                                //transformOrigin: "left 50%",
                                ease: Power2.easeInOut,
                                stagger: 0.25,
                            });
                        }
                    }
                } catch (error) {
                    
                }
                
            }

            //----------------------------------------------
            // TAF PIERRICK
            //----------------------------------------------
            //
            //            if (value === 'animBookFormIsInView') {
                        //    console.log("--------------- anim BOOK FORM ---------------");
            //                if (way === 'enter') {
            //                    gsap.from(".informationPickDates", {
            //                        //                    y: "-30%",
            //                        opacity: 0,
            //                        duration: 1,
            //                        delay: 0.2,
            //                    });
            //                    gsap.from(".datepick-multi tr", {
            //                        //                    y: "-30%",
            //                        opacity: 0,
            //                        duration: 1,
            //                        delay: 0.2,
            //                        stagger: function (index, target, list) {
            //                            return index * 0.05;
            //                        }
            //                    });
            //
            //                    gsap.from(".twoColsForm .booking_form_field", {
            //                        //                    y: "-30%",
            //                        opacity: 0,
            //                        duration: 1,
            //                        delay: 0.8,
            //                        stagger: function (index, target, list) {
            //                            return index * 0.05;
            //                        }
            //                    });
            //                }
            //            }
            if (value === "showSideMenu" && !sideMenuShown) {
                // console.log("--------------- anim showSideMenu ---------------");
                sideMenuShown = true;
                if (
                    way === "enter" &&
                    !mobile &&
                    document.querySelector(".housePageAnchors")
                ) {
                    document
                        .querySelector(".housePageAnchors")
                        .classList.add("showSideMenu");
                    document
                        .querySelector("#backgroundPageAnchors")
                        .classList.add("showSideMenu");
                    setTimeout(function() {
                        if (document.querySelector(".housePageAnchors")) {
                            document
                                .querySelector(".housePageAnchors")
                                .classList.remove("showSideMenu");
                            document
                                .querySelector("#backgroundPageAnchors")
                                .classList.remove("showSideMenu");
                        }
                    }, 4500);
                }
            }
        });
    }, 700);

    document.querySelector('.arrow-footer')?.addEventListener('click', (e) => {
        e.preventDefault();
        scroll.scrollTo(0,0);
    })


    // var offset;
    //
    // function getTopOffsetElement(element) {
    //
    //     var rect = element.getBoundingClientRect();
        //console.log(rect.top, rect.right, rect.bottom, rect.left);
    //
    //     var bodyRect = document.body.getBoundingClientRect(),
    //         elemRect = element.getBoundingClientRect();
    //     offset = elemRect.top - bodyRect.top;
    //
    // }
})();